export default function Navbar() {
  return (
    <nav className="bg-white shadow px-4 sm:px-6 py-3 flex items-center justify-center">
      
      <h1 className="font-extrabold text-gray-800 tracking-tight
                     text-sm sm:text-lg md:text-xl lg:text-2xl
                     whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        Smart Hostel Management System
      </h1>

    </nav>
  );
}
